import axios from "axios";
import HOST_URL from "./utils/Url"; // adjust path if needed

// Set base URL globally
axios.defaults.baseURL = HOST_URL.HOST_URL2 || HOST_URL.HOST_URL;

// ✅ 1. Attach token for every request (सिवाय USERLOGIN के)
axios.interceptors.request.use(
  (config) => {
    const isLoginRequest = config.url?.toLowerCase().includes("userlogin");
    const token = sessionStorage.getItem("token");

    // Login रिक्वेस्ट पर टोकन नहीं भेजना है, बाकी सभी पर Bearer Token जुड़ेगा
    if (token && !isLoginRequest) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ 2. Handle 401 globally (LOGIN रिक्वेस्ट को छोड़ कर)
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const requestUrl = error.config?.url?.toLowerCase() || "";

    // 🛡️ FIX 1: अगर रिक्वेस्ट LOGIN की है, तो रीडायरेक्ट बिल्कुल मत करो
    // ताकि LoginPage एरर टोस्ट दिखा सके
    if (requestUrl.includes("userlogin")) {
      return Promise.reject(error);
    }

    // 🛡️ FIX 2: अगर यूजर पहले से ही लॉगिन पेज पर है, तो भी रिफ्रेश मत करो
    const currentPath = window.location.pathname.toLowerCase();
    if (currentPath === "/" || currentPath === "/login") {
      return Promise.reject(error);
    }

    // 🛡️ सिर्फ तभी लॉगआउट करें जब यूजर अंदर किसी प्रोटेक्टेड पेज (जैसे Dashboard) पर हो
    if (error.response && error.response.status === 401) {
      console.error("Unauthorized! Redirecting to login...");
      sessionStorage.clear();
      localStorage.clear();
      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);

export default axios;